import React from "react";

const Footer = () => {
  return (
    <>
      <div
        className="container-fluid bg-dark footer mt-5 py-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Thông tin chung</h4>
              <a className="btn btn-link" href="/code-of-conduct">
                Quy tắc ứng xử
              </a>
              <a className="btn btn-link" href="/policy">
                Chính sách bảo mật
              </a>
              <a className="btn btn-link" href="/disclaimer">
                Miễn trừ trách nhiệm
              </a>
              <a className="btn btn-link" href="/contact-us">
                Hỗ trợ
              </a>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Gói vay</h4>
              <a className="btn btn-link" href="">
                Vay Tín chấp
              </a>
              <a className="btn btn-link" href="">
                Vay mua ô tô
              </a>
              <a className="btn btn-link" href="">
                Vay tiêu dùng trả góp
              </a>
              <a className="btn btn-link" href="">
                Vay mua xe máy trả góp
              </a>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Giờ mở cửa</h4>
              <p className="mb-1">Thứ 2 - Thứ 6</p>
              <h6 className="text-light">08:30 am - 18:00 pm</h6>
              <p className="mb-1">Thứ 7</p>
              <h6 className="text-light">08:30 am - 12:00 pm</h6>
              <p className="mb-1">Chủ nhật</p>
              <h6 className="text-light">Đóng cửa</h6>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-4">Liên Hệ</h4>
              <p className="mb-2">
                <i className="fa fa-map-marker-alt me-3"></i>
                <a
                  href="https://maps.app.goo.gl/pqdaMuLwYWjFVZHu5"
                  target="_blank"
                  className="text-white no-underline-link"
                >
                  271 Nguyễn Văn Linh, Thanh Khê, Đà Nẵng
                </a>
              </p>
              <p className="mb-2">
                <i className="fa fa-phone-alt me-3"></i>
                <a
                  href="tel::0838598518"
                  className="text-white no-underline-link"
                >
                  +0838598518
                </a>
              </p>
              <div className="d-flex pt-3">
                <a href="">
                  <img
                    src="/img/icon/zalo-black-icon.png"
                    className="btn btn-square btn-light rounded-circle me-2 p-0"
                  />
                </a>
                <a
                  className="btn btn-square btn-light rounded-circle me-2"
                  href="https://www.facebook.com/shinhanfinance.official.vietnam"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  className="btn btn-square btn-light rounded-circle me-2"
                  href="https://bit.ly/ShinhanFinance_Youtubeofficial"
                >
                  <i className="fab fa-youtube"></i>
                </a>
                <a
                  className="btn btn-square btn-light rounded-circle me-2"
                  href="https://www.linkedin.com/company/shinhan-finance-official/"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid copyright py-4">
        <div className="container">
          <div className="row">
            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
              {/* &copy;
              <a className="fw-medium text-light" href="#">
                Your Site Name
              </a>
              , All Right Reserved. */}
              Tôi là Nhân viên kinh doanh của Shinhan Finance. Tôi cam đoan hoàn
              toàn tự chịu trách nhiệm trước những nội dung, hình ảnh, ý kiến,
              tương tác của tôi trên website. Toàn bộ những hoạt động này của
              tôi đại diện cho mong muốn và quan điểm cá nhân, không mang tính
              chất đại diện hay ủy quyền phát ngôn thay cho Shinhan Finance.
            </div>
            {/* <div className="col-md-6 text-center text-md-end">
              Designed By
              <a className="fw-medium text-light" href="https://htmlcodex.com">
                HTML Codex
              </a>
              Distributed By
              <a className="fw-medium text-light" href="https://themewagon.com">
                ThemeWagon
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
